import {useEffect, useState} from "react";
import axios from "axios";
import {API} from "../../helpers/constants";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../helpers/errorHandling";
import useUserData from "../user/useUserData";
import {useTranslation} from "react-i18next";
import {DASHBOARD} from "../../locales/components/namespaces";

const useOrderIndexData =()=>{
    const [loading, setLoading] = useState(false);
    const [orderData, setOrderData] = useState([])
    const {token} = useUserData()
    const { t } = useTranslation(DASHBOARD);


useEffect(()=>{
    setLoading(true)
    axios({
        method: 'post',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        url: `${API}/en/brew/order/index`
    }).then((res) => {
     const data = res.data.data;
     setOrderData(data.orders);
        setLoading(false)
    }).catch((error) => {
        setLoading(false)
        enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
            variant: 'error',
            autoHideDuration: 3000,
        })
    })
},[])
    return {
        loading,
        orderData
    }
}
export default useOrderIndexData